import React from 'react';
import MultipleCategoriesAction from "@/Pages/Categories/Assets/MultipleCategoriesAction/MultipleCategoriesAction";

const CategoriesBottomPanel = ({handleCheckAll, checked, parentCheckbox}) => {
  return (
    <tfoot className='border-t'>
    <tr>
      <td className="px-1 pt-5 pb-4 w-1">
        <input type="checkbox" onChange={handleCheckAll} ref={parentCheckbox} defaultChecked={false}/>
      </td>
      <td>
        <MultipleCategoriesAction checked={checked}/>
      </td>
    </tr>
    </tfoot>
  );
};

export default CategoriesBottomPanel;
